"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _translationUtils = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/utils/translationUtils"));

var _utils = _interopRequireDefault(require("../../utils"));

var _windowWrapper = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/sdk/windowWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var GalleryEmpty =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(GalleryEmpty, _React$Component);

  function GalleryEmpty() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = GalleryEmpty.prototype;

  _proto.componentWillMount = function componentWillMount() {
    this.props.actions.setWixHeight(390, _windowWrapper["default"].innerHeight); //TODO-NewGalleryContianer - remove this function because the functionality is now in the TPAwrapper
  };

  _proto.render = function render() {
    if (_utils["default"].isVerbose()) {
      console.log('Not rendering - gallery is empty');
    }

    var emptyContent = _utils["default"].isStoreGallery() ? _react["default"].createElement("div", null, _react["default"].createElement("div", {
      className: "pro-gallery-empty-title"
    }, _translationUtils["default"].getByKey('Gallery_ArtStore_Organize_Images_EmptyState_Header'), _react["default"].createElement("br", null), _translationUtils["default"].getByKey('Gallery_ArtStore_Organize_Images_EmptyState_Header2')), _react["default"].createElement("div", {
      className: "pro-gallery-empty-info"
    }, _translationUtils["default"].getByKey('Gallery_ArtStore_Organize_Images_EmptyState_Text'), _react["default"].createElement("br", null))) : _react["default"].createElement("div", null, _react["default"].createElement("div", {
      className: "pro-gallery-empty-title"
    }, _translationUtils["default"].getByKey('Gallery_Empty_Title'), _react["default"].createElement("br", null), _translationUtils["default"].getByKey('Gallery_Empty_Title2')), _react["default"].createElement("div", {
      className: "pro-gallery-empty-info"
    }, _translationUtils["default"].getByKey('Gallery_Empty_Description'), _react["default"].createElement("br", null), _translationUtils["default"].getByKey('Gallery_Empty_Description2')));
    return _react["default"].createElement("div", {
      className: "pro-gallery-empty"
    }, _react["default"].createElement("div", {
      className: "pro-gallery-empty-wrapper"
    }, _react["default"].createElement("div", {
      className: "pro-gallery-empty-image"
    }), emptyContent));
  };

  return GalleryEmpty;
}(_react["default"].Component);

var _default = GalleryEmpty;
exports["default"] = _default;